export default {
  label: {
    emptyData: {
      title: 'No hay datos para el contrato y bot(s) seleccionado(s)',
      description: 'Seleccione otro contrato y otro bot en los filtros para ver los datos.',
    },
    emptyBot: {
      title: 'No fue posible cargar los datos',
      description: 'Seleccione un bot y un contrato en los filtros para ver los datos.',
    },
    error: {
      title: '',
      description: 'Error al cargar los datos',
    },
    supportsOnlyOneBot: {
      title: 'No fue posible cargar los datos',
      description: 'Este componente solo admite la selección de un bot a la vez.',
    },
  },
};
